import React from "react";
import cx from "clsx";
import styles from "./styles.module.scss";

export const Options = ({ list, selected, onSelect }) => (
  <div className={styles.root}>
    {list
      .map((x) => x.trim())
      .filter(Boolean)
      .map((item, index) => (
        <button
          key={index}
          className={cx(styles.option, {
            [styles.selected]: selected.filter(Boolean).includes(item),
          })}
          onClick={() => onSelect(item)}
        >
          {item}
        </button>
      ))}
  </div>
);
